export default function (context, value) {
    context.dispatch('settings/open', 'payments', {root: true});
}